<template>
  <formulaire-view :steps="steps" :step="step" url="/demande-stage/" paramsName="demande_stage" :endpoint="endpoint" :getRefs="$refs">
    <template v-slot:step="{ sas, path, setState, code }">
      <component :is="path" :sas="sas" @validation-changed="setState(path, $event)" :ref="path" :endpoint="endpoint">
        <ressource :code="code" />
      </component>
    </template>
  </formulaire-view>
</template>

<script>
import FormulaireView from "@/views/FormulaireView.vue"
import Identification from "@/components/Formulaires/DemandeStage/Identification"
import InformationsStage from "@/components/Formulaires/DemandeStage/InformationsStage"
import Declaration from "@/components/Formulaires/DemandeStage/Declaration"

export default {
  props: {
    step: String
  },
  data() {
    return {
      endpoint: "demande-stage",
      steps: [
        { path: "introduction", code: "titre-introduction", state: "" },
        { path: "identification", code: "titre-etape-1", state: "" },
        { path: "informations-stage", code: "titre-etape-2", state: "" },
        { path: "declaration", code: "titre-etape-3", state: "" },
        { path: "soumission", code: "titre-soumission" }
      ]
    }
  },

  components: {
    FormulaireView,
    Identification,
    InformationsStage,
    Declaration
  }
}
</script>